import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ViewController } from 'ionic-angular';
import { ApiService } from "../../services/api.service";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import {XpSearchUnitPage} from "../xp-search-unit/xp-search-unit";
import {XpWorkorderService} from "../../services/xp-workorder.service";

@Component({
  selector: 'page-xp-search-location-units',
  templateUrl: 'xp-search-location-units.html',
})
export class XpSearchLocationUnitsPage {

  searchPerformed = false;
  busy = false;
  page: XpSearchUnitPage;

  searchType = 1;
  query = '';
  zipcode = '';
  number = '';
  units = [];

  dummyData = {
    "unit_id": "60",
    "parent_unit_id": "0",
    "unit_version_id": "1",
    "location_id": "52",
    "time_created": "0",
    "time_updated": "0",
    "time_deleted": null,
    "time_registered": "1561104042",
    "time_warranty": null,
    "time_installation": null,
    "time_recycled": null,
    "passport_nr": "NL22M00000870665105",
    "serial_nr": "JJBEA10945690366078",
    "unit_nr": null,
    "new_serial_nr": null,
    "new_passport_nr": null,
    "status": "1",
    "unit_data": {
      "unit_id": "60",
      "unit_version_id": "1",
      "location_id": "52",
      "time_created": "1561104042",
      "time_updated": "1561104042",
      "passport_nr": "NL22M00000870665105",
      "serial_nr": "JJBEA10945690366078",
      "status": "1",
      "unit_data": {
        "unit_brand_id": "1",
        "unit_model": "Q-serie",
        "unit_model_id": "1",
        "unit_version": "Q25C",
        "unit_version_id": "1",
        "title": "",
        "serialnumber": "5555555",
        "passport_nr": "6666666",
        "year": "2018",
        "nominal_power": "",
        "o2_config_model": "",
        "o2_config_user": "",
        "openings": "Ja",
        "fuel_type": "Aardgas",
        "cascade": "Nee",
        "unit_type": "HR",
        "configuration_type": "Open toestel",
        "exhaust_type": "Excentrisch",
        "exhaust_location": "Dak",
        "service_interval": "24",
        "list_title": "ATAG Q-serie Q25C",
        "list_subtitle": "6666666",
        "status": 1,
        "_selected": true,
        "location_id": "52"
      },
      "time_next_maintenance": "1622498400",
      "time_next_maintenance_ignore": null,
      "unit_version": "Q25C",
      "unit_model": "Q-serie",
      "unit_model_id": "1",
      "unit_brand": "ATAG",
      "unit_brand_id": "1",
      "list_title": "ATAG Q-serie Q25C",
      "list_subtitle": "NL22M00000870665105",
      "_selected": true,
      "title": "",
      "year": "2014",
      "nominal_power": "",
      "o2_config_model": "",
      "co2_config_model": "",
      "o2_config_user": "",
      "co2_config_user": "",
      "openings": "Ja",
      "fuel_type": "Aardgas",
      "cascade": "Nee",
      "unit_type": "HR",
      "configuration_type": "Open toestel",
      "het_nieuwe_beugelen": "Ja",
      "exhaust_type": "Excentrisch",
      "exhaust_location": "Dak",
      "service_interval": "24",
      "installation_space": "",
      "_changed": true,
      "unit_nr": "NL22M00000870665105"
    },
    "time_next_maintenance": "1625090400",
    "time_next_maintenance_ignore": null,
    "contract_id": "0",
    "planner_unit_id": null,
    "company_id": "2",
    "street": "Hofstraat",
    "number": "4",
    "letter": "C",
    "zipcode": "5801BJ",
    "city": "Venray",
    "country": "NL",
    "older_than_ten_years": null,
    "gps_lat": "51.5271677",
    "gps_lon": "5.9761625",
    "gps_result_code": null,
    "gps_result_message": null,
    "planner_location_id": null,
    "firstname": "T.",
    "lastname": "van der Test",
    "files": [],
    "unit_version": "Q25C",
    "unit_model": "Q-serie",
    "unit_model_unit_type": "1",
    "unit_model_id": "1",
    "unit_brand": "ATAG",
    "unit_brand_warranty_status": "1",
    "unit_brand_warranty_email": "info@atagverwarming.nl",
    "unit_brand_id": "1",
    "latest_reports": [],
    "list_title": "ATAG - Q-serie \/ Q25C - NL22M00000870665105",
    "list_subtitle": "Teststraat 1, 1234 AB, Teststad"
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public barcodeScanner: BarcodeScanner,
    public workorderService: XpWorkorderService,
    public apiService: ApiService
  ) {
    this.page = navParams.get('page');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SearchLocationUnitsPage');
  }

  isValid(){
    if(
      this.query.trim()
    ){
      return true;
    }
    return false;
  }

  scanBarcode(){
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      // Detect appstore QR codes
      if(
        barcode.indexOf('https://apps.apple.com/') !== -1 ||
        barcode.indexOf('https://play.google.com/') !== -1
      ){
        this.alertCtrl.create({
          message: 'Ya tenés XtraPush instalado. Escaneá el QR de la máquina para cargar sus datos.',
          buttons: ['OK']
        }).present();
        return;
      }
      // Detect invalid QR code
      if(
        barcode.indexOf('https://mntnz.nl/') === -1 &&
        barcode.length !== 19
      ){
        this.alertCtrl.create({
          message: 'Este no es un QR de máquina. Escaneá el QR de la máquina para cargar sus datos.',
          buttons: ['OK']
        }).present();
        return;
      }
      // Strip url
      if(barcode.lastIndexOf('/') > 0) {
        barcode = barcode.substring(barcode.lastIndexOf('/') + 1);
      }
      if(barcode){
        this.query = barcode;
        this.search();
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  search(){
    if(!this.isValid()){
      return;
    }
    this.searchPerformed = false;
    this.units = [];
    this.busy = true;

    setTimeout(() => {
      let dummyData: any = Object.assign({}, this.dummyData);
      if(this.workorderService.getCountry() === 'BE'){
        dummyData.passport_nr = 'BE22M00000870665105';
        dummyData.unit_data.passport_nr = 'BE22M00000870665105';
        dummyData.list_title = 'ATAG - Q-serie \/ Q38CR - BE22M00000870665105';
        dummyData.list_subtitle = 'Teststraat 1, 1234, Teststad';
        dummyData.unit_version = 'Q38CR';
        dummyData.unit_data.unit_version = 'Q38CR';
      }
      if(this.workorderService.getCountry() === 'UY'){
        dummyData.passport_nr = 'UY22M00000870665105';
        dummyData.unit_data.passport_nr = 'UY22M00000870665105';
        dummyData.list_title = 'ATAG - Q-series \/ Q38CR - UY22M00000870665105';
        dummyData.list_subtitle = 'Calle de Prueba 1, 1234, Ciudad de Prueba';
        dummyData.unit_version = 'Q38CR';
        dummyData.unit_data.unit_version = 'Q38CR';
      }
      this.units = [dummyData];
      this.busy = false;
      this.searchPerformed = true;
    }, 1500);
  }

  select(unit){
    this.page.search(unit);
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-search-location-units/xp-search-location-units.ts